export const MODAL_HEADER_FONT_SIZE = 28;
export const MODAL_HEADER_FONT_WEIGHT = 350;
export const INTERVAL_MILLISECONDS = 1000;
export const IDLE_WAIT_IN_MILLISECONDS = 60000;
export const IDLE_WAIT_IN_SECONDS = 60;
export const COUNT_DOWN_IN_SECONDS = 15;
export const MODAL_HEADER_FONT_WEIGHT_BOLD = 500;
export const TEXT_COLOR = "#626F71";
export const TEXT_COLOR_DISABLED = "#C4C4C4";
export const ACCENT_COLOR = "#5DADE2";
export const BACKGROUND_COLOR = "#D9D9D9";
export const ORDER_INITIAL_START_HOUR_OFFSET = -2;
export const ORDER_INITIAL_END_HOUR_OFFSET = 2;
export const DISABLED_INPUT_COLOR = "#e6e6e6";
export const DISABLED_BUTTON_COLOR = "#e0e0e0";

export const INITIAL_START_HOUR_OFFSET = -2;
export const INITIAL_END_HOUR_OFFSET = 2;
export const INITIAL_START_HOUR_OFFSET_STOCK_TRANSACTION_MODAL = -24;
export const START_DATE_INDEX = 0;
export const END_DATE_INDEX = 1;
export const DATE_PICKER_ANIMATION_PERCENTAGE = 52;
export const ALL_LOCATIONS_VALUE = "$INTRNL";
export const ALL_TRANSACTIONS = "0";

export const EQUIVALENT_MODAL = "openEquivalentModal";
export const ADD_TO_LIST_OR_START_MODAL =
  "openAddToListOrStartProcessWithSingleItemModal";
export const NO_ITEM_OR_EQUIVALENT_MODAL = "openNoItemOrNoEquivalentModal";
export const STRING_EMPTY = "";
export const APPROVE_COUNT_MODAL = "openApproveCountModal";
export const APPROVE_COUNT_QUESTION_MODAL = "openApproveCountQuestionModal";
export const ZERO_VALUE = 0;
export const REQUIRED_WITNESS_QUANTITY = 4;
export const COMPONENT_COMMAND_DELAY_MS = 500;
export const UNEXPIRED_TOKEN =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJVc2VySWQiOiI3NjFhMzVkOC04Njk5LTRmN2EtYjBlNy04YTQ0OTU2OGVmNDEiLCJVc2VyTmFtZSI6Im1lbGloLmNvYmFuIiwiRmFjaWxpdHlJZCI6IjZhZTMxZDY1LWY2MzEtNDgyMC1hM2I3LWEwNTBmMzM0ZDI2OSIsIlVzZXJBdXRob3JpemF0aW9ucyI6WyIxMDEiLCIxMDExIiwiMTAxMiIsIjEwMiIsIjEwMjEiLCIxMDIyIiwiMTAzIiwiMTAzMSIsIjEwMzIiLCIyMDEiLCIyMDExIiwiMjAxMiIsIjIwMiIsIjIwMjEiLCIyMDIyIiwiMjAzIiwiMjAzMSIsIjIwMzIiLCIyMDQiLCIyMDQxIiwiMjA0MiIsIjIwNSIsIjIwNTEiLCIyMDUyIiwiMjA2IiwiMjA2MSIsIjIwNjIiLCIyMDciLCIyMDcxIiwiMjA3MiIsIjMwMSIsIjMwMTEiLCIzMDEyIiwiMzAyIiwiMzAyMSIsIjMwMyIsIjMwMzEiLCIzMDMyIiwiNDAxIiwiNDAxMSIsIjQwMTIiLCI0MDEzIiwiNTAxIiwiNTAxMSIsIjUwMTIiLCI1MDE0IiwiNTAxNSIsIjUwMTYiLCI2MDEiLCI2MDIiLCI2MDIxIiwiNzAxIiwiNzAyIiwiOTk5Il0sIm5iZiI6MTcwMTA3MTM1OSwiZXhwIjoxNzMyNjkzNzU5LCJpc3MiOiJodHRwOi8vbG9jYWxob3N0OjcwNTIiLCJhdWQiOiJhc3RvcmVwbHVzYXBpIn0.5GQfm6bcwM7APCfmyxmou3PBhYlV7sxKmawUwq4Ap9I";
export const KEYPAD_LIST = [
  "Numpad0",
  "Numpad1",
  "Numpad2",
  "Numpad3",
  "Numpad4",
  "Numpad5",
  "Numpad6",
  "Numpad7",
  "Numpad8",
  "Numpad9",
  "Digit1",
  "Digit2",
  "Digit3",
  "Digit4",
  "Digit5",
  "Digit6",
  "Digit7",
  "Digit8",
  "Digit9",
  "Digit0",
  "Backspace",
  "NumpadDecimal",
  "Backslash",
];

export const ALL = "-1";
export const IN_STOCK = "1";
export const EMPTY_GUID = "00000000-0000-0000-0000-000000000000";
export const ALL_PATIENT_LOCATION_CODE = "$INTRNL";
export const LEFT_SECTION_FLEX_GAP = 5;
export const FLEX_BUTTON_GAP = 8.5;
export const FLEX_GAP_XS = 10;
export const FLEX_GAP_MD = 16;
export const CHECKBOX_TOP_MARGIN = 25;
export const SPACE_TO_FLEX_GAP = 300;
